import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColoredBackgroundTop = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 1439.68 519",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0H1439.68V460.735C1439.68 460.735 1002.27 518.107 719.839 518.107C437.413 518.107 0 460.735 0 460.735V0Z",
			fill: "#FFF3EB"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_dddd_8784_102060)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M1116.86 131.018C1116.45 131.346 1115.93 131.533 1115.36 131.502C1114.13 131.441 1113.17 130.395 1113.21 129.158C1113.43 123.016 1111.41 116.986 1107.53 112.173C1102.21 105.564 1094.01 102.006 1085.61 102.661C1084.37 102.754 1083.29 101.835 1083.18 100.6C1083.07 99.3645 1083.97 98.2856 1085.21 98.1927C1095.1 97.4207 1104.74 101.611 1111 109.383C1115.57 115.05 1117.95 122.15 1117.69 129.369C1117.66 130.042 1117.34 130.626 1116.86 131.012L1116.86 131.018Z",
					fill: "#00884B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1134.86 136.358C1134.39 136.732 1133.78 136.916 1133.15 136.823C1131.92 136.643 1131.06 135.503 1131.23 134.279C1132.85 122.356 1129.42 110.109 1121.82 100.677C1113.01 89.7438 1099.43 83.5883 1085.5 84.2102C1084.26 84.2693 1083.21 83.3075 1083.14 82.0701C1083.06 80.8327 1084.01 79.7924 1085.25 79.7334C1100.6 79.0471 1115.58 85.8368 1125.28 97.8879C1133.67 108.291 1137.45 121.787 1135.66 134.934C1135.58 135.519 1135.28 136.013 1134.86 136.358Z",
					fill: "#00884B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1151.75 120.787C1151.45 121.027 1151.08 121.191 1150.68 121.251C1149.46 121.419 1148.32 120.568 1148.14 119.345C1146.53 108.618 1142.05 98.4408 1135.18 89.9131C1128.31 81.3854 1118.5 74.2426 1107.77 70.4577C1106.6 70.0432 1105.98 68.7713 1106.38 67.6024C1106.78 66.4335 1108.05 65.8248 1109.21 66.245C1120.73 70.3141 1130.92 77.5329 1138.65 87.1339C1146.38 96.735 1150.83 107.221 1152.56 118.744C1152.68 119.552 1152.35 120.329 1151.76 120.802L1151.75 120.787Z",
					fill: "#00884B"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_dddd_8784_102060)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M365.819 308.834C366.081 309.305 366.187 309.861 366.07 310.419C365.819 311.642 364.636 312.401 363.417 312.115C357.367 310.707 351.083 311.553 345.72 314.495C338.356 318.534 333.574 326.039 332.933 334.562C332.836 335.811 331.758 336.72 330.518 336.588C329.278 336.457 328.348 335.344 328.445 334.095C329.198 324.062 334.829 315.237 343.489 310.487C349.803 307.023 357.202 306.026 364.313 307.686C364.976 307.838 365.506 308.271 365.815 308.826L365.819 308.834Z",
					fill: "#00884B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M374.178 292.228C374.478 292.767 374.568 293.409 374.377 294.03C374.011 295.219 372.748 295.857 371.56 295.455C359.986 291.517 347.313 292.574 336.793 298.348C324.598 305.04 316.41 317.43 314.886 331.499C314.755 332.746 313.64 333.611 312.401 333.445C311.163 333.279 310.277 332.129 310.408 330.882C312.086 315.377 321.118 301.711 334.56 294.335C346.164 287.967 360.128 286.805 372.89 291.145C373.458 291.338 373.902 291.732 374.178 292.228Z",
					fill: "#00884B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M361.82 272.802C362.012 273.148 362.119 273.552 362.116 273.972C362.095 275.228 361.073 276.208 359.83 276.153C348.921 275.672 338.115 278.197 328.581 283.437C319.048 288.676 310.438 297.143 305.023 307.19C304.431 308.287 303.072 308.66 301.971 308.031C300.871 307.402 300.461 306.008 301.058 304.92C306.877 294.132 315.62 285.306 326.354 279.407C337.087 273.508 348.195 271.082 359.914 271.591C360.736 271.624 361.457 272.109 361.836 272.793L361.82 272.802Z",
					fill: "#00884B"
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter2_dddd_8784_102060)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M95.8535 336.298C95.984 336.441 96.1146 336.593 96.2403 336.746C97.8018 338.588 98.9621 340.774 99.5857 343.169C99.9338 344.488 100.113 345.869 100.113 347.293V352.788C100.113 354.716 100.446 356.564 101.065 358.283C102.211 361.483 104.338 364.23 107.084 366.178C107.534 366.497 107.998 366.792 108.481 367.064C109.361 367.564 110.294 367.992 111.271 368.33C113.011 368.935 114.892 369.268 116.85 369.268C118.807 369.268 120.683 368.935 122.428 368.33C127.186 366.678 130.952 362.964 132.629 358.278C133.248 356.559 133.586 354.712 133.586 352.783C133.586 350.855 133.248 349.007 132.629 347.288C132.102 345.807 131.358 344.422 130.444 343.164C128.462 340.46 125.677 338.365 122.428 337.236C120.683 336.631 118.803 336.298 116.85 336.298H95.8535Z",
				fill: "#FF9C31"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_dddd_8784_102060)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1353.69 198.609C1353.82 198.466 1353.95 198.314 1354.08 198.161C1355.64 196.319 1356.8 194.133 1357.43 191.738C1357.77 190.419 1357.95 189.038 1357.95 187.614V182.119C1357.95 180.191 1358.29 178.343 1358.9 176.624C1360.05 173.424 1362.18 170.677 1364.92 168.729C1365.37 168.41 1365.84 168.115 1366.32 167.843C1367.2 167.343 1368.13 166.915 1369.11 166.577C1370.85 165.972 1372.73 165.639 1374.69 165.639C1376.65 165.639 1378.52 165.972 1380.27 166.577C1385.03 168.229 1388.79 171.943 1390.47 176.629C1391.09 178.348 1391.43 180.195 1391.43 182.124C1391.43 184.052 1391.09 185.9 1390.47 187.619C1389.94 189.1 1389.2 190.486 1388.28 191.743C1386.3 194.447 1383.52 196.542 1380.27 197.671C1378.52 198.276 1376.64 198.609 1374.69 198.609H1353.69Z",
				fill: "#FF375B"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dddd_8784_102060",
				x: 1074.66,
				y: 64.228,
				width: 86.4075,
				height: 103.705,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .942012 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.41302 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.65207 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.82604 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_8784_102060",
						result: "effect2_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 12.2462 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.76805 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_8784_102060",
						result: "effect3_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 22.6083 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.23905 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_8784_102060",
						result: "effect4_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_8784_102060",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_dddd_8784_102060",
				x: 292.306,
				y: 269.641,
				width: 90.6498,
				height: 98.0463,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .942012 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.41302 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5.65207 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2.82604 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_8784_102060",
						result: "effect2_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 12.2462 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3.76805 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_8784_102060",
						result: "effect3_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 22.6083 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.23905 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_8784_102060",
						result: "effect4_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_8784_102060",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dddd_8784_102060",
				x: 91.1435,
				y: 327.82,
				width: 119.688,
				height: 91.3751,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 3.76805,
						dy: 1.88402
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.23905 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 13.1882,
						dy: 6.59408
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 7.53609 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_8784_102060",
						result: "effect2_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 30.1444,
						dy: 15.0722
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.89112 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_8784_102060",
						result: "effect3_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 53.6947,
						dy: 26.3763
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 11.7751 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_8784_102060",
						result: "effect4_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_8784_102060",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dddd_8784_102060",
				x: 1348.98,
				y: 157.161,
				width: 119.688,
				height: 91.3752,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 3.76805,
						dy: 1.88402
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.23905 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 13.1882,
						dy: 6.59408
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 7.53609 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_8784_102060",
						result: "effect2_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 30.1444,
						dy: 15.0722
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 9.89112 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_8784_102060",
						result: "effect3_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 53.6947,
						dy: 26.3763
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 11.7751 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.27451 0 0 0 0 0.156863 0 0 0 0 0.32549 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_8784_102060",
						result: "effect4_dropShadow_8784_102060"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_8784_102060",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgColoredBackgroundTop;
